export default __webpack_public_path__ + "static/media/GridActive.0e0316d0.svg";